module.exports = __webpack_public_path__ + "static/img/logo-a.75660bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo-a.png
// module id = QKsd
// module chunks = 0